import { PublicationsService, PublicPublicationsOrderBy } from "../client"

/* TYPES */
export type TagsFieldProps = {
  value: string | null
  onChange: (id: string | null, name: string | null) => void
}


/* ENDPOINTS */
export const getSearchResults = ({
  authorId,
  categoryId,
  dateFrom,
  dateTo,
  descending,
  orderBy,
  query,
  page,
  tagId,
} : {
  authorId: string | null,
  categoryId: string | null,
  dateFrom: string | null,
  dateTo: string | null,
  descending: boolean,
  orderBy: PublicPublicationsOrderBy,
  query: string | null,
  page: number,
  tagId: string | null,
}) => {
  return {
        queryFn: async () => {
            const data = await PublicationsService.readPublicationsPublic({
              authorId: authorId,
              categoryId: categoryId,
              dateFrom: dateFrom,
              dateTo: dateTo,
              descending: descending,
              orderBy: orderBy,
              query: query,
              skip: page,
              tagId: tagId,
            })
            return data ?? { data: null, count: 0 }
        },
        queryKey: ["search", {
          authorId,
          categoryId,
          dateFrom,
          dateTo,
          descending,
          orderBy,
          query,
          page,
          tagId,
        }],
    }
}


/* FUNCTIONS */
export const formatDate = (value: any) => {
  if (!value) return null

  const date = new Date(value.toString())
  if (isNaN(date.getTime())) return null

  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, "0")
  const day = String(date.getDate()).padStart(2, "0")

  return `${year}-${month}-${day}`
}
